export default "__VITE_ASSET__tghJmVvE__"